module.exports = __webpack_public_path__ + "static/media/22.983a348e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/22.svg
// module id = 395
// module chunks = 14